import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

import { CACHES } from '@personal-area/common';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private readonly _caches = inject(CACHES);
  private readonly _platformId = inject(PLATFORM_ID);

  clearCache(pattern = /^(ngsw).*api.*/): void {
    if (isPlatformServer(this._platformId)) {
      return;
    }

    this._caches.keys().then((keys) => {
      keys.forEach((eachCacheName) => {
        if (pattern.test(eachCacheName)) {
          this._caches.open(eachCacheName).then((eachCache) => {
            eachCache.keys().then((requests) => {
              requests.forEach((eachRequest) => {
                eachCache.delete(eachRequest);
              });
            });
          });
        }
      });
    });
  }
}
